import axios from 'axios';

export default {
  getList(_, params) {
    return axios.get('Payment/GetList', { params });
  },
  getDetail(_, id) {
    return axios.get('Payment/GetDetail', { params: { id } });
  },
  reject(_, id) {
    return axios.get('Payment/Reject', { params: { id } });
  },
  approve(_, id) {
    return axios.get('Payment/Approve', { params: { id } });
  },
  viewFile2(_, path) {
    return axios.get('Payment/viewFile', { params: { path } , responseType: 'blob' });
  },
};
